// Выпадающие списки шапки на десктопе. На ширине <= 1160px те же пункты
// работают как аккордеон внутри мобильного меню (mobile-menu.js).
const SUBMENU_DESKTOP_QUERY = window.matchMedia('(max-width: 1160px)');

const submenuItems = document.querySelectorAll('.topbar-item_submenu');

submenuItems.forEach((elem) => {
  const casesArrow = elem.querySelector('.submenu_block__arrow');
  const casesBlock = elem.querySelector('.submenu_block');

  let isOpenCases = false;

  const onClickCases = () => {
    if (SUBMENU_DESKTOP_QUERY.matches) return;

    isOpenCases = !isOpenCases;
    isOpenCases ? showCases() : hideCases();
  };

  const showCases = () => {
    casesBlock.style.display = 'block';
    casesArrow.style.transform = 'rotate(0.5turn)';
    elem.classList.add('topbar_submenu');
  };

  const hideCases = () => {
    casesBlock.style.display = 'none';
    casesArrow.style.transform = 'rotate(0turn)';
    elem.classList.remove('topbar_submenu');
  };

  const resetCases = () => {
    casesBlock.style.display = '';
    casesArrow.style.transform = '';
    elem.classList.remove('topbar_submenu');
    isOpenCases = false;
  };

  elem.addEventListener('click', onClickCases);

  document.addEventListener('click', (e) => {
    if (SUBMENU_DESKTOP_QUERY.matches || e.composedPath().includes(elem)) {
      return;
    }

    const withinBoundaries = e.composedPath().includes(casesBlock);
    if (!withinBoundaries && isOpenCases) {
      hideCases();
      isOpenCases = false;
    }
  });

  // при смене разрешения снимаем инлайновые стили, чтобы меню не залипало
  SUBMENU_DESKTOP_QUERY.addEventListener('change', resetCases);
});
